export default {
    cptDataForm: {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute: {
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        defaultValueType: null,
        defaultValue: '',
        label: '标题：',
        labelAlign:'right',
        labelWidth:100,
        labelBoolean:true,
        placeholder: '请输入',
        size: 'medium', 
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor: '#00000000',
        textColor: '#fff',
        textPlaceholderColor: '#333',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        textColor: '#ffffff',
        borderSize: 1,
        borderColor: '#333333',
        borderRadius: 0,
        lineType: 'solid',
        required: false,
        parentId: '',
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
    },
    interaction: { eventText: '完成输入时' }
}